// frontend/src/services/googleMapsPopup.js
// PopupOverlay: overlay nativo de Google Maps para mostrar popups
// con estilos propios (sin el iframe/burbuja blanca del InfoWindow nativo).
// Extiende google.maps.OverlayView de forma imperativa.

export function crearPopupOverlay() {
  // La clase se define en tiempo de llamada para que google.maps ya esté cargado
  class PopupOverlay extends window.google.maps.OverlayView {
    constructor() {
      super();
      this._div = document.createElement('div');
      this._div.style.cssText = [
        'position:absolute',
        'pointer-events:none',
        'display:none',
        // transform: centrar horizontalmente y posicionar encima del pin
        'transform:translate(-50%, calc(-100% - 16px))',
        'z-index:10',
      ].join(';');
    }

    onAdd() {
      this.getPanes().overlayMouseTarget.appendChild(this._div);
    }

    draw() {
      if (!this._position) return;
      const proj = this.getProjection();
      if (!proj) return;
      const point = proj.fromLatLngToDivPixel(this._position);
      if (!point) return;
      this._div.style.left = point.x + 'px';
      this._div.style.top  = point.y + 'px';
    }

    onRemove() {
      if (this._div.parentNode) this._div.parentNode.removeChild(this._div);
    }

    mostrar(latLng, html) {
      this._position = latLng;
      this._div.innerHTML = html;
      this._div.style.display = 'block';
      this.draw();
    }

    ocultar() {
      this._div.style.display = 'none';
    }

    destruir() {
      this.setMap(null);
    }
  }

  return new PopupOverlay();
}
